
import JokeSetup from './components/JokeSetup';
import './styles/App.css';

function App() {
  return (
    <div className='main'>
      <JokeSetup />
    </div>
  );
}

export default App;
